<template>
  <section id="schedule" class="page-box">
    <h1 class="title">{{ $t("menu.schedule") }}</h1>
    <el-row :gutter="20" class="schedule-list">
      <el-col :sm="24" :md="12">
        <a
          data-fancybox="schedule-1"
          :href="require('@/assets/images/schedule-1-1.jpg')"
          class="fancybox"
          ><el-card class="box-card" shadow="hover">
            <p><i class="el-icon-date"></i> December 4 , 2026</p>
          </el-card>
        </a>
        <!-- <a
          data-fancybox="schedule-1"
          :href="require('@/assets/images/schedule-1-2.png')"
          class="fancybox"
        >
        </a> -->
      </el-col>
      <el-col :sm="24" :md="12"
        ><a
          data-fancybox="schedule-2"
          :href="require('@/assets/images/schedule-2-1.jpg')"
          class="fancybox"
          ><el-card class="box-card" shadow="hover">
            <p><i class="el-icon-date"></i> December 5 , 2026</p>
          </el-card>
        </a>
        <!-- <a
          data-fancybox="schedule-2"
          :href="require('@/assets/images/schedule-2-2.png')"
          class="fancybox"
        >
        </a> -->
      </el-col>
    </el-row>
  </section>
</template>

<script>
export default {
  name: "ScheduleComponent",
  props: {
    msg: String,
  },
};
</script>
